import React, { useState } from 'react';
import './Register.css';
import { usePromiseTracker } from "react-promise-tracker";
import { Oval } from 'react-loading-icons'
import { validateUser } from '../services/ValidateUser';
import { registerUser } from '../services/register';
import { confirmAlert } from 'react-confirm-alert';


export default function Register() {
    const { promiseInProgress } = usePromiseTracker(); 
    const[CUI, setCUI] = useState();
    const[UserInformation, setUserInformation] = useState({});
    const[NotificationType, setNotificationType] = useState({});

    const validateEmail = (email) => {
        return String(email)
          .toLowerCase()
          .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          );
      };

      const mensaje = (respuesta, registro) =>{
        confirmAlert({
            customUI: ({ onClose }) => {
              return (
                <div className='custom-ui modal-register'>
                  <h1>{respuesta}</h1>
                  <center>
                  <button
                      className="button-modal-single"
                      onClick={() => {
                        onClose();
                      }}
                    >
                      Aceptar
                    </button>   
                    </center>         
                </div>
              );
            }
          });
    }

    function validateUsers(){   
        if(CUI){
            validateUser(CUI)
            .then(response => {
                if(!response.statusCode){
                    setUserInformation(response);
                }else
                mensaje(response.body, true);
            })
        }else{
            mensaje("Por favor ingrese un CUI válido", true);
            setCUI("");
            setUserInformation({});
            setNotificationType({});
        } 
        
    }

    function Registrar(){
        var dateParts = UserInformation.ciffecnacimie.split("/");
        var mydate = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]); 

        let day = mydate.getDate()
        let month = mydate.getMonth() + 1
        let year = mydate.getFullYear()
        let Nacimiento;
        if(month < 10){
            Nacimiento = `${year}-0${month}-${day}`;
        }else{
            Nacimiento = `${year}-${month}-${day}`;
        }

        if((validateEmail(UserInformation.cifinternet) && NotificationType==='C') || (UserInformation.cifceltelefono.toString().length>2  && NotificationType==='T')){
            registerUser({  "CUI": CUI, 
            "CIF": UserInformation.cifcodcliente, 
            "Nombre": UserInformation.cifnombreclie, 
            "Correo": UserInformation.cifinternet,
            "Telefono":UserInformation.cifceltelefono, 
            "Medio": NotificationType,
            "Nacimiento": Nacimiento,
            "Activo": UserInformation.cuentaapor
                    }) 
            .then(response => {
            mensaje(response.body, true);
            setCUI("");
            setUserInformation({});
            setNotificationType({});
            })

        }else{
            mensaje("Te debes avocar a tu agencia más cercana para actualizar tu información y proceder con el Registro.", true);
        }

    
        
    }



    return(
        <div className="main other-component" style={{ backgroundImage: "url(/Fondo5.png)"}}>
            <div className="login-wrapper card-register">
                <div className="text-card-register"> 
                  <div>Bienvenido, ingresa tu número de Código Único de Identificación (CUI) </div>
                </div>
                <center>
                    <input className="input" placeholder="CUI" value={CUI} onChange={e =>{ setCUI(e.target.value);setUserInformation({}); setNotificationType({});}} type="number" />
                </center>
                { (Object.keys(UserInformation).length < 4)? (
                    <div></div>
                ):(
                    <div className="text-card-register"> 
                        <div>Por favor verifica que tus datos personales sean válidos antes de continuar. sí deseas modificar tus datos personales por favor acércate a tu agencia Guadalupana más cercana.</div>
                        <table className='table-space'> 
                            <tr><td><b>Nombre:</b>             </td><td><div className='user-text'>{UserInformation.cifnombreclie}</div> </td></tr>
                            <tr><td><b>CIF:</b>                </td><td><div className='user-text'>{UserInformation.cifcodcliente}</div> </td></tr>
                            <tr><td><b>Correo electrónico:</b> </td><td><div className='user-text'>{UserInformation.cifinternet}</div>   </td></tr>
                            <tr><td><b>Teléfono:</b>           </td><td><div className='user-text'>{UserInformation.cifceltelefono}</div></td></tr>
                            <tr><td><b>Fecha nacimiento:</b>   </td><td><div className='user-text'>{UserInformation.ciffecnacimie.replace("00:00:00", "")}</div></td></tr>
                        </table>
                        <div>Selecciona el medio de envio de credenciales.</div>
                        <div className="radio">
                            {( UserInformation.cifinternet !==null)?(
                                <div>
                                    <input placeholder="mail" onChange={e => setNotificationType("C")} type="radio" name="type"/>
                                    Correo electrónico
                                </div>
                            ):(
                                <div></div>
                            )}
                            {( UserInformation.cifceltelefono !==null)?(
                                <div>
                                     <input placeholder="télefono" onChange={e => setNotificationType("T")} type="radio" name="type" />
                                     Teléfono
                                </div>
                            ):(
                                <div></div>
                            )}
                    </div>
                    </div>
                )} 
                    <div className="btns">
                     {(Object.keys(NotificationType).length === 0)?(
                        <center>
                            <button className="button-candidate button-register" onClick={ validateUsers } disabled={ promiseInProgress ? "disabled" : "" } > 
                                { promiseInProgress ? "Registrar..." : "Registrar"} 
                                { promiseInProgress && <Oval className="loading-icon" /> }
                            </button>
                        </center>
                     ):(
                        <div></div>
                     ) }   
                        

                      

                    { (Object.keys(NotificationType).length === 0 || Object.keys(UserInformation).length < 4)? (
                        <div></div>
                    ):(
                        <center>
                            <button className="button-candidate button-register" onClick={ Registrar } disabled={ promiseInProgress ? "disabled" : "" } > 
                                { promiseInProgress ? "Registrar..." : "Registrar"} 
                                { promiseInProgress && <Oval className="loading-icon" /> }
                            </button>
                        </center>
                    )}
                </div>  
            </div> 
        </div> 
    )
}

